module.exports = __webpack_public_path__ + "static/media/boomea-red.d5716554.svg";